import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { getEscalationContact } from '../services/userService';
import type { EscalationContact } from '../types/api';

// Who Proxy's "Escalate to manager" goes to today: the Proxy/ICT manager, or
// their backup while they're out. Set on the Admin Dashboard; the backend
// works out who's covering (GET /auth/escalation-contact/cary).
const PROXY_TEAM_ID = 'cary';

interface EscalationContactValue {
  contact: EscalationContact | null;
  refresh: () => void;
}

const EscalationContactContext = createContext<EscalationContactValue>({ contact: null, refresh: () => {} });

export function EscalationContactProvider({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  const [contact, setContact] = useState<EscalationContact | null>(null);

  const refresh = useCallback(() => {
    getEscalationContact(PROXY_TEAM_ID).then(setContact).catch(() => setContact(null));
  }, []);

  useEffect(() => { if (user) refresh(); else setContact(null); }, [user, refresh]);

  return (
    <EscalationContactContext.Provider value={{ contact, refresh }}>
      {children}
    </EscalationContactContext.Provider>
  );
}

export const useEscalationContact = () => useContext(EscalationContactContext);
